/* eslint-disable react/no-unescaped-entities */
import React, { Fragment } from "react"
import {
  faFacebookF,
  faLinkedinIn,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons"
import Stack from "../../layout/Stack/Stack"
import Row from "../../layout/Row/Row"

import SmartLink from "../../layout/SmartLink/SmartLink"
import {
  ABOUT_US_URL,
  CARE_NEWS_URL,
  COOKIE_POLICY_URL,
  FACEBOOK_URL,
  LINKEDIN_URL,
  PRIVACY_POLICY_URL,
  TWITTER_URL,
  geoBreakdownDirectoryPath,
} from "../../../utils/paths"

import { footer, socialLink } from "./styles.module.scss"
import { InlineText } from "../../Typography/Typography"
import Icon from "../../layout/icon"

const links = [
  { to: ABOUT_US_URL, label: "About CareSourcer" },
  { to: PRIVACY_POLICY_URL, label: "Privacy policy" },
  { to: COOKIE_POLICY_URL, label: "Cookie policy" },
  { to: geoBreakdownDirectoryPath(), label: "Locations" },
  { to: geoBreakdownDirectoryPath("care_home"), label: "Care Home Locations" },
  {
    to: geoBreakdownDirectoryPath("care_home", "dementia"),
    label: "Dementia Care Home Locations",
  },
  { to: geoBreakdownDirectoryPath("home_care"), label: "Home Care Locations" },
  { to: CARE_NEWS_URL, label: "Care Advice" },
]

const social = [
  {
    to: FACEBOOK_URL,
    label: "facebook",
    icon: faFacebookF,
  },
  { to: TWITTER_URL, label: "twitter", icon: faTwitter },
  {
    to: LINKEDIN_URL,
    label: "linkedin",
    icon: faLinkedinIn,
  },
]

const Footer = () => (
  <footer className={footer}>
    <Stack>
      <Row wrap justifyCenter>
        {social.map(({ to, icon, label }) => (
          <SmartLink to={to} key={to} aria-label={label} className={socialLink}>
            <InlineText white>
              <Icon icon={icon} />
            </InlineText>
          </SmartLink>
        ))}
      </Row>
      <Row wrap justifyCenter>
        {links.map(({ to, label }, i) => (
          <Fragment key={label}>
            {i > 0 && " | "}
            <SmartLink to={to}>
              <InlineText white>{label}</InlineText>
            </SmartLink>
          </Fragment>
        ))}
      </Row>
      <Row justifyCenter>
        <InlineText white small>
          © {new Date().getFullYear()} KareHero Ltd. "Care Sourcer" is a brand
          name that is owned by KareHero Ltd, whose company number is 14314900,
          registered at 128 City Road, London, EC1V 2NX
        </InlineText>
      </Row>
    </Stack>
  </footer>
)

export default Footer
